var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.isLoggedIn)?_c('keep-alive',[(_vm.$route.meta.keepAlive)?_c('router-view',{staticStyle:{"min-height":"100%"}}):_vm._e()],1):_vm._e(),(!_vm.$route.meta.keepAlive || !_vm.isLoggedIn)?_c('router-view',{staticStyle:{"min-height":"100%"}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }